import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'

type optionsType = ReactQueryOptions['CollectionManager']['getBonusToy']
type inputType = RouterInputs['CollectionManager']['getBonusToy']

export const useGetBonusToy = (input: inputType, options?: optionsType) =>
    api.CollectionManager.getBonusToy.useQuery(input, {
        ...options,
        queryKey: ['CollectionManager.getBonusToy', input],
        refetchOnWindowFocus: false,
        staleTime: 60 * 60 * 1000 * staleTimeIndex // 1 hour
    })
